<template>
  <div class="select-contacts">
    <div class="form-group mt-4">
      <div>
        <input
          type="search"
          name="search"
          id="search"
          class="form-control"
          :placeholder="$t('invite.searchPlaceholder')"
          v-model="searchText"
        />
      </div>
    </div>
    <div class="font-weight-bold selected-contact">
      <div class="display-left">
        {{ $t('invite.selected') + ' (' + selectedContacts.length + ')' }}
      </div>
      <div
        v-if="selectedContacts.length > 0"
        class="display-right"
        @click="removeAllSelectedContact()"
      >
        {{ $t('invite.removeAll') }}
      </div>
    </div>
    <div class="contacts-box selected">
      <div
        class="selected-item"
        v-for="contact in selectedContacts"
        :key="contact.id"
      >
        <strong>{{ contact.name }}</strong>
        {{ ' &lt;' + contact.email + '&gt;' }}
        <font-awesome-icon
          class="ml-3 pointer"
          :icon="['fal', 'trash-alt']"
          @click="toggleContactSelect(contact)"
        />
      </div>
    </div>
    <div class="font-weight-bold mt-2 selected-contact">
      <div class="display-left">
        {{ $t('invite.searchResults') }}
      </div>
      <div class="display-right k-flex">
        <p @click="selectAllContact()">
          {{ $t('invite.selectAll') }}
        </p>
        <p class="ml-2" @click="removeAllSelectedContact()">
          {{ $t('invite.deSelectAll') }}
        </p>
      </div>
    </div>
    <div class="contacts-box list">
      <div
        class="contact-item"
        v-for="contact in filteredContacts"
        :key="contact.id"
      >
        <div>
          <div class="contact-icon">
            {{ getInitials(contact.name) }}
          </div>
        </div>
        <div
          class="contact-details pointer"
          @click="toggleContactSelect(contact)"
        >
          <div class="contact-user">
            <div
              class="contact-name"
              :class="{ 'particpant-contact': contact.isParticipant }"
            >
              {{ contact.name }}
              <span class="" v-if="contact.isParticipant">
                {{ $t('invite.alreadyParticipating') }}
              </span>
            </div>
            <div class="contact-email">
              {{ contact.email }}
            </div>
          </div>
          <div class="contact-select">
            <div class="checked-circle" v-if="contact.selected">
              <font-awesome-icon class="" :icon="['fal', 'check']" />
            </div>
            <div
              class="participant-checked-circle"
              v-else-if="contact.isParticipant"
            >
              <font-awesome-icon class="" :icon="['fal', 'check']" />
            </div>
            <div v-else class="empty-circle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import shared from '@/shared.js';
export default {
  name: 'SelectPollContacts',

  props: ['poll', 'mycontacts'],
  data() {
    let sortOrders = {};

    sortOrders.name = 1;
    sortOrders.email = 1;
    return {
      sortOrders: sortOrders,
      searchText: '',
      searchKeys: ['name', 'email', 'status', 'polls_count'],
      contacts: [],
    };
  },

  computed: {
    selectedContacts() {
      //this.resetAck();
      let selected = this.contacts.filter((contact) => contact.selected);
      let sortKey = 'name';
      selected = selected.slice().sort(function (a, b) {
        a = a[sortKey].toLowerCase();
        b = b[sortKey].toLowerCase();
        return a === b ? 0 : a > b ? 1 : -1;
      });

      return selected;
    },

    filteredContacts: function () {
      let sortKey = this.sortKey || 'name';
      let filterKey = this.searchText && this.searchText.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      let contacts = this.contacts;
      let searchKeys = this.searchKeys;
      if (filterKey) {
        contacts = contacts.filter(function (contact) {
          return Object.keys(contact).some(function (key) {
            return (
              searchKeys.includes(key) &&
              String(contact[key]).toLowerCase().indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey) {
        contacts = contacts.slice().sort(function (a, b) {
          a = a[sortKey].toLowerCase();
          b = b[sortKey].toLowerCase();
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return contacts;
    },
  },

  methods: {
    toggleContactSelect(contact) {
      //   if (contact.selected) {
      //     contact.selected = false;
      //     let index = this.selectedContactsArr.findIndex(
      //       (item) => item.id === contact.id
      //     );
      //     if (index > -1) {
      //       this.selectedContactsArr.splice(index, 1);
      //     }
      //   } else {
      //     contact.selected = true;
      //     this.selectedContactsArr.push(contact);
      //   }
      console.log('send event toggleContactSelect for ', contact);
      contact.selected = !contact.selected;
      this.$emit('toggleContactSelect', contact);
    },

    removeAllSelectedContact() {
      console.log('removeAllSelectedContact');
      for (const contact of this.filteredContacts) {
        if (contact.isParticipant) continue;
        contact.selected = false;
        // this.$emit('selectContactSelect', contact);
      }
    },

    selectAllContact() {
      for (const contact of this.filteredContacts) {
        if (contact.isParticipant) continue;

        contact.selected = true;
        this.$emit('selectContactSelect', contact);
      }
    },
  },

  created() {
    this.getInitials = shared.getInitials;

    this.poll.participants.forEach((p) => {
      if (p.user) {
        const c = this.mycontacts.find((c) => c.email.toLowerCase()  == p.user.email.toLowerCase() );
        if (c) {
          const contact = {
            id: c.id,
            name: p.name,
            email: p.user.email,
            selected: false,
            isParticipant: c.isParticipant,
          };
          this.contacts.push(contact);
        } else {
          console.error('contact not found for participant:', p);
        }
      }
    });
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/style';

.contacts-box {
  background-color: white;
  border-radius: 5px;
  padding: 15px;
  border: 1px solid $light-grey;

  overflow: auto;
  width: 100%;
  overflow-x: hidden;
  &.list {
    max-height: 575px;
  }
  &.selected {
    max-height: 125px;
  }
}

.contact-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.contact-icon {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding-left: 0px;
  padding-top: 8px;
  display: block;
  background: $user-bubble;
  border: 0px solid;
  color: $dark-grey;
  text-align: center;
  font: 14px Arial, sans-serif;
  margin-right: 1rem;
  text-transform: uppercase;
}

.contact-details {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid $light-grey;
  width: 100%;
}

.contact-user {
  display: flex;
  flex-direction: column;
  width: 80%;
}

.contact-name {
  font-weight: bold;
  color: $dark-grey;
}

.contact-email {
  font-weight: normal;
  color: $light-grey;
  font-size: 0.8rem;
}

.contact-select {
  align-self: center;
}

.checked-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: $dark-grey;
  border: 1px solid $dark-grey;
  color: white;
  text-align: center;
}

.participant-checked-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: $light-grey;
  border: 1px solid $light-grey;
  color: white;
  text-align: center;
}

.empty-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: white;
  border: 1px solid $dark-grey;
  color: white;
  padding: 6px;
}

.display-left {
  float: left;
}

.display-right {
  cursor: pointer;
  color: $primary;
  float: right;
}

.selected-contact {
  margin-bottom: 40px;
}

.particpant-contact {
  color: $light-grey !important;
  span {
    color: $primary !important;
  }
}

@media (max-width: 767px) {
  .contacts-box {
    &.list {
      max-height: 300px;
    }
  }
}
</style>
